import React, { useState, useEffect, useRef } from 'react';
import { Plus } from './icons';
export function TableHoverControls({ editor }) {
    const [colControl, setColControl] = useState(null);
    const [rowControl, setRowControl] = useState(null);
    const hideTimeoutRef = useRef(null);
    useEffect(() => {
        if (!editor)
            return;
        const clearControls = () => {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            setColControl(null);
            setRowControl(null);
        };
        const handleMouseMove = (e) => {
            const target = e.target;
            // If hovering over the control button itself, keep it visible
            if (target.closest('.table-hover-control')) {
                if (hideTimeoutRef.current) {
                    clearTimeout(hideTimeoutRef.current);
                    hideTimeoutRef.current = null;
                }
                return;
            }
            const cell = target.closest('td, th');
            const table = target.closest('table');
            // If not inside a table or cell within TipTap, hide controls immediately
            if (!cell || !table || !cell.closest('.tiptap')) {
                clearControls();
                return;
            }
            const cellRect = cell.getBoundingClientRect();
            const tableRect = table.getBoundingClientRect();
            const mouseX = e.clientX;
            const mouseY = e.clientY;
            const THRESHOLD = 16;
            let newColControl = null;
            let newRowControl = null;
            // Check right border for column add button (within THRESHOLD of cell's right edge, inside table vertical bounds)
            if (Math.abs(cellRect.right - mouseX) <= THRESHOLD &&
                mouseY >= tableRect.top - 20 &&
                mouseY <= tableRect.bottom + 20) {
                newColControl = { x: cellRect.right, y: tableRect.top - 12, cellDOM: cell };
            }
            // Check bottom border for row add button (within THRESHOLD of cell's bottom edge, inside table horizontal bounds)
            if (Math.abs(cellRect.bottom - mouseY) <= THRESHOLD &&
                mouseX >= tableRect.left - 20 &&
                mouseX <= tableRect.right + 20) {
                newRowControl = { x: tableRect.left - 12, y: cellRect.bottom, cellDOM: cell };
            }
            if (!newColControl && !newRowControl) {
                // If cursor is inside the table but not near any actionable border, clear controls
                clearControls();
            }
            else {
                if (hideTimeoutRef.current) {
                    clearTimeout(hideTimeoutRef.current);
                    hideTimeoutRef.current = null;
                }
                setColControl(newColControl);
                setRowControl(newRowControl);
            }
        };
        const handleMouseLeave = () => {
            clearControls();
        };
        const handleScroll = () => {
            clearControls();
        };
        const container = document.getElementById('editor-area') || document.body;
        container.addEventListener('mousemove', handleMouseMove);
        container.addEventListener('mouseleave', handleMouseLeave);
        window.addEventListener('scroll', handleScroll, true);
        editor.on('blur', clearControls);
        editor.on('update', clearControls);
        return () => {
            container.removeEventListener('mousemove', handleMouseMove);
            container.removeEventListener('mouseleave', handleMouseLeave);
            window.removeEventListener('scroll', handleScroll, true);
            editor.off('blur', clearControls);
            editor.off('update', clearControls);
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
            }
        };
    }, [editor]);
    const addColumn = (cellDOM) => {
        try {
            const pos = editor.view.posAtDOM(cellDOM, 0);
            editor.chain().focus().setTextSelection(pos).addColumnAfter().run();
        }
        catch (err) {
            console.error('Failed to add column:', err);
        }
        setColControl(null);
        setRowControl(null);
    };
    const addRow = (cellDOM) => {
        try {
            const pos = editor.view.posAtDOM(cellDOM, 0);
            editor.chain().focus().setTextSelection(pos).addRowAfter().run();
        }
        catch (err) {
            console.error('Failed to add row:', err);
        }
        setColControl(null);
        setRowControl(null);
    };
    return (<>
      {colControl && (<button type="button" onMouseDown={(e) => e.preventDefault()} className="table-hover-control col-control" style={{ position: 'fixed', left: colControl.x, top: colControl.y, zIndex: 1000 }} onClick={() => addColumn(colControl.cellDOM)} title="Add Column">
          <Plus size={14}/>
        </button>)}
      {rowControl && (<button type="button" onMouseDown={(e) => e.preventDefault()} className="table-hover-control row-control" style={{ position: 'fixed', left: rowControl.x, top: rowControl.y, zIndex: 1000 }} onClick={() => addRow(rowControl.cellDOM)} title="Add Row">
          <Plus size={14}/>
        </button>)}
    </>);
}
